import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize, Subject, takeUntil } from 'rxjs';
import { AreaBlacklistAddDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/area-blacklist-add-dto';
import { AreaBlacklistDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/area-blacklist-dto';
import { AreaBlacklistService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
    selector: 'app-area-blacklist-add-dialog',
    templateUrl: './area-blacklist-add-dialog.component.html',
    styleUrls: ['./area-blacklist-add-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AreaBlacklistAddDialogComponent implements OnInit {
  form: UntypedFormGroup;
  unsubscribe$ = new Subject<void>();

  get areaBlacklistZip() {
    return this.form.get('areaBlacklistZip');
  }

  get areaBlacklistPlaceName() {
    return this.form.get('areaBlacklistPlaceName');
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: AreaBlacklistService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
    public dialogRef: MatDialogRef<AreaBlacklistAddDialogComponent>
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      areaBlacklistZip: [null],
      areaBlacklistPlaceName: [null],
    });
  }

  async create() {
    let data: AreaBlacklistAddDto = {
      areaBlacklistPlaceName: this.areaBlacklistPlaceName.value != '' ? this.areaBlacklistPlaceName.value : null,
      areaBlacklistZip: this.areaBlacklistZip.value != '' ? this.areaBlacklistZip.value : null,
    };

    this.loader.show();
    await this.service
      .addAreaBlacklist({ caller: EGIS_SERVICE_CALLER, body: data })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (result: AreaBlacklistDto) => {
          this.dialogRef.close(result);
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );
  }
}
